<script setup>
const props = defineProps({
    modelValue: {
        type: Boolean,
        required: true,
    },
    label: {
        type: String,
        default: 'Mostrar Todos',
    },
    tooltip: {
        type: String,
        default: null,
    },
    class: {
        type: String,
        default: 'w-13rem',
    },
});

defineEmits(['update:modelValue']);
</script>

<template>
    <Button
        :label="label"
        :class="props.class"
        size="small"
        :icon="modelValue ? 'pi pi-filter' : 'pi pi-filter-slash'"
        :severity="modelValue ? 'success' : 'secondary'"
        :outlined="!modelValue"
        v-tooltip.bottom="tooltip"
        @click="$emit('update:modelValue', !modelValue)"
    />
</template>
